import { useCallback, useEffect, useState } from "react";
import { galleryImages } from "assets/img/gallery/images";

export default function ImageGallery() {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const closeLightbox = useCallback(() => setSelectedIndex(null), []);

    const showPrev = useCallback(() => {
        setSelectedIndex((i) => (i === null ? i : (i - 1 + galleryImages.length) % galleryImages.length));
    }, []);

    const showNext = useCallback(() => {
        setSelectedIndex((i) => (i === null ? i : (i + 1) % galleryImages.length));
    }, []);

    useEffect(() => {
        if (selectedIndex === null) return undefined;

        function onKeyDown(e) {
            if (e.key === "Escape") closeLightbox();
            if (e.key === "ArrowLeft") showPrev();
            if (e.key === "ArrowRight") showNext();
        }

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [selectedIndex, closeLightbox, showPrev, showNext]);

    if (galleryImages.length === 0) {
        return (
            <p className="text-center text-lg text-gray-600">
                Photos coming soon!
            </p>
        );
    }

    const selectedImage = selectedIndex === null ? null : galleryImages[selectedIndex];

    return (
        <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {galleryImages.map((image, i) => (
                    <button
                        key={i}
                        type="button"
                        onClick={() => setSelectedIndex(i)}
                        className="bg-white shadow-lg rounded-lg overflow-hidden cursor-pointer group"
                    >
                        <img
                            src={image.src}
                            alt={image.alt || ""}
                            loading="lazy"
                            style={{ objectPosition: image.objectPosition || "center" }}
                            className="w-full h-64 object-cover transition-transform duration-200 group-hover:scale-105"
                        />
                    </button>
                ))}
            </div>

            {selectedImage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 p-4"
                    onClick={closeLightbox}
                >
                    <button
                        type="button"
                        onClick={closeLightbox}
                        className="absolute top-4 right-4 text-white text-3xl leading-none"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); showPrev(); }}
                        className="absolute left-2 sm:left-4 text-white text-4xl leading-none p-2 hover:text-gray-300"
                        aria-label="Previous image"
                    >
                        &#8249;
                    </button>
                    <img
                        src={selectedImage.src}
                        alt={selectedImage.alt || ""}
                        className="max-h-full max-w-full rounded-lg"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); showNext(); }}
                        className="absolute right-2 sm:right-4 text-white text-4xl leading-none p-2 hover:text-gray-300"
                        aria-label="Next image"
                    >
                        &#8250;
                    </button>
                </div>
            )}
        </>
    );
}